import { Component, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { UploadFileDialogComponent } from '../../dialogs/upload-file-dialog/upload-file-dialog.component';
import { DocumentConstants } from 'app/constants/document.constants';
import { FormService } from 'app/services/form.service';
import { AttachmentModel } from 'app/models/attachment.model';

@Component({
  selector: 'app-additional-documentation',
  templateUrl: './additional-documentation.component.html',
  styleUrls: ['./additional-documentation.component.scss']
})
export class AdditionalDocumentationComponent {
  readonly dialog = inject(MatDialog);

  constructor(protected formService: FormService) {}

  public openDialog(): void {
    const dialogRef = this.dialog.open(UploadFileDialogComponent, {
          data: { fileName: DocumentConstants.ADDITIONAL_DOCUMENTATION }
        });
    dialogRef.afterClosed().subscribe();
  }

  get hasAdditionalDocumentation(): boolean {
    return this.formService.doesCurrentFormHaveAttachmentForSection(DocumentConstants.ADDITIONAL_DOCUMENTATION);
  }

  get attachments(): AttachmentModel[] {
    return this.formService.allAttachmentsForSection(DocumentConstants.ADDITIONAL_DOCUMENTATION);
  }

   get formType(): string {
    return this.formService.getCurrentUsanFormType();
  }

  get isFormDType(): boolean {
    return 'FormD' === this.formType;
  }
}
